import { render, staticRenderFns } from "./CurrentSemiProductionStock.vue?vue&type=template&id=1367fd34&"
import script from "./CurrentSemiProductionStock.vue?vue&type=script&lang=js&"
export * from "./CurrentSemiProductionStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports